<template>
  <div
    v-if="serviceList"
    class="main">
    <module-title :module-title="moduleTitle"/>
    <!-- <ul class="service double-between">
      <li
        v-for="(item,index) in serviceList"
        :key="index"
        :class="index>1?'margin-top':''"
        class="item flex"
        @click="goDoc(item)">
        <img
          :src="item.img"
          class="imgs ljb-size100">
        <div class="flex1 text-item">
          <p class="ljb-title title">{{ item.title }}</p>
          <p class="ljb-md-text text">{{ item.tag }}</p>
        </div>
      </li>
    </ul> -->
    <div class="service">
      <div class="service-top double-between">
        <div class="service-htmb" @click="goDoc('/lawyerLetter')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_flsh3.png">
          <div class="title">发律师函</div>
          <!-- <div class="text">2000元/份起</div> -->
        </div>
        <div class="service-htmb" @click="goDoc('/SubDoc/faceConsult')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_jmzx3.png">
          <div class="title">见面咨询</div>
          <!-- <div class="text">500元/小时起</div> -->
        </div>
        <div class="service-htsc" @click="goDoc('/CommitDoc')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_htsc3.png">
          <div class="title">合同审查</div>
          <!-- <div class="text">1000元/份起</div> -->
        </div>
      </div>
      <div class="service-top double-between" style="margin-top: 10px">
        <div class="service-htmb" @click="goDoc('/SubDoc/docModule')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_htmb3.png">
          <div class="title">合同模板</div>
          <!-- <div class="text">高效便捷有保障</div> -->
        </div>
        <div class="service-htmb" @click="goDoc('/draftDoc')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_htqc3.png">
          <div class="title">合同起草</div>
          <!-- <div class="text">1000元/份起</div> -->
        </div>
        <div class="service-htsc" @click="goDoc('/SubDoc/lawsuit')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_ddgs3.png">
          <div class="title">代打官司</div>
          <!-- <div class="text">3000元/案起</div> -->
        </div>
      </div>
      <!-- <div class="service-bottom double-between">
        <div class="service-left" @click="goDoc('/SubDoc/lawsuit')">
          <img src="https://cdn.51ljb.cn/ljb_icon_service_ddgs2.png">
          <div class="title">代打官司</div>
          <div class="text">3000元/案起</div>
        </div>
        <div class="service-right">
          <div class="service-jmzx" @click="goDoc('/SubDoc/faceConsult')">
            <img src="https://cdn.51ljb.cn/ljb_icon_service_jmzx2.png">
            <div class="title">见面咨询</div>
            <div class="text">1000元/次</div>
          </div>
          <div class="service-flsh" @click="goDoc('/SubDoc/lawyerLetter')">
            <img src="https://cdn.51ljb.cn/ljb_icon_service_flsh2.png">
            <div class="title">发律师函</div>
            <div class="text">2000元/份起</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import ModuleTitle from '@/components/title/ModuleTitleNew'
import {mapGetters} from 'vuex'
let namespce = 'Channel'
export default {
  name: 'ListService',
  components: {ModuleTitle},
  data () {
    return {
      moduleTitle: {
        title: '热门服务'
      }
      // serviceList: [{
      //   img: 'https://cdn.51ljb.cn/ljb-icon_docCheck.png',
      //   title: '文书审核',
      //   tag: '规避法律风险',
      //   url: '/SubDoc'
      // }, {
      //   img: 'https://cdn.51ljb.cn/ljb-icon_docMoudle.png',
      //   title: '文书模板',
      //   tag: '高效便捷有保障',
      //   url: '/SubDoc'
      // }]
    }
  },
  computed: {
    ...mapGetters(namespce, ['getChannelData']),
    serviceList () {
      if (this.getChannelData) {
        if (this.getChannelData.activity && Object.keys(this.getChannelData.activity).length > 0) {
          return this.getChannelData.activity
        }
      }
      return null
    }
  },
  methods: {
    goDoc: function (item) {
      // this.$utils.checkCanGoRouter(item.url)
      this.$router.push(item)
    }
  }
}
</script>

<style lang="scss" scoped>
  .main{
    // margin-top: $margin;
    background: #fff;
    padding-bottom: $padding;
  }
  .title{
    position: absolute;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    letter-spacing: 2px;
    top: 10px;
    left: 10px;
  }
  .text{
    position: absolute;
    font-size: 12px;
    font-weight: 400;
    color: #AAAAAA;
    top: 37px;
    left: 10px;
  }
  .service{
    padding: 0 $padding;
    padding-top: $padding;
    box-sizing:  border-box;
    .service-top{
      width: 100%;
      height: 80px;
      >div{
        width: 110px;
        position: relative;
        >img{
          width: 100%;
          height: 80%;
        }
      }
    }
    .service-bottom{
      width: 100%;
      height: 206px;
      margin-top: 8px;
      .service-left{
        width: 167px;
        position: relative;
        >img{
          width: 100%;
          height: 100%;
        }
      }
      .service-right{
        width: 167px;
        >div{
          width: 100%;
          height: 100px;
          position: relative;
          >img{
            width: 100%;
            height: 100%;
          }
        }
        >.service-flsh{
          margin-top: 8px;
        }
      }
    }
  }
  

</style>



// WEBPACK FOOTER //
// src/components/list/ListServiceNew.vue